import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ShareIcon from "@material-ui/icons/Share";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import v1 from "../videos/video1.mp4"
import v2 from "../videos/video2.mp4"
import v3 from "../videos/video3.mp4"
import v4 from "../videos/video4.mp4"
import v5 from "../videos/video5.mp4"
import v6 from "../videos/video6.mp4"
import v7 from "../videos/video7.mp4"
import v8 from "../videos/video8.mp4"
import v9 from "../videos/video9.mp4"
import v10 from "../videos/video10.mp4"

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%'
  },
  media: {
    height: 250,
    width:'100%',
    border:"none",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  }
}));

export default function RecipeReviewCard() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
      <>
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            1
          </Avatar>
        }
        title="Meme 1"
        subheader="1 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v1} controls oncontextmenu="return false;" controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #LockDown #Comedy #meme #Funny #School #Fun #Video
        </Typography>
      </CardContent>
      <CardActions disableSpacing> 
      <a href={v1} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>
 




    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            2
          </Avatar>
        }
        title="Meme 2"
        subheader="2 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v2} controls controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #Hahahaha #Christmas_Fun #Comedy #Meme #Funny #True_Love #Video
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
      <a href={v2} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>
    
    
    
    
    
    
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            3
          </Avatar>
        }
        title="Meme 3"
        subheader="3 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v3} controls controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #JethaLal_Memes #Jethiya #meme #Lawyer #Dance #Video #Savage
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
      <a href={v3} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>
    
    
    
    
    
    
    
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            4
          </Avatar>
        }
        title="Meme 4"
        subheader="4 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v4} controls controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #Uttrakhand_Meme #UK #Dehradun_meme #Funny #Indira_Market #Tshirt #Price
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
      <a href={v4} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>
    
    
    
    
    
    
    
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            5
          </Avatar>
        }
        title="Meme 5"
        subheader="5 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v5} controls controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #Pubg #Honest_Guy #Noob_meme #Pubg_Memes #Fun #Jai_Pubg
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
      <a href={v5} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>
    
    
    
    
    
    
    
    
    
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            6
          </Avatar>
        }
        title="Meme 6"
        subheader="6 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v6} controls controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #WWE #Comedy #Video #Funny #Scripted #Video
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
      <a href={v6} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>
    
    
    
    
    
    
    
    
    
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            7
          </Avatar>
        }
        title="Meme 7"
        subheader="7 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v7} controls controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #Love #True_Love #Car_Drive #Couple_meme #Funny #Car_Crash #Drive_Safe
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
      <a href={v7} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>
    
    
    
    
    
    
    
    
    
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            8
          </Avatar>
        }
        title="Meme 8"
        subheader="8 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v8} controls controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #Goat_sings_Better #Sings #Comedy #meme #Funny #Singer #Fun #Video
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
      <a href={v8} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>
    
    
    
    
    
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            9
          </Avatar>
        }
        title="Meme 9"
        subheader="9 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v9} controls controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #Toothless_Flirt #Flirt #ToothLess #Funny #Comedy #LOL
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
      <a href={v9} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>





    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
           10
          </Avatar>
        }
        title="Meme 10"
        subheader="10 July, 2020"
      />
      <CardMedia
        // component="video"
        className={classes.media}
        // src={v1}
        style={{width:"100%"}}
      >
<video src={v10} controls controlsList="nodownload" style={{width:"100%", height:"-webkit-fill-available", outline:"none"}}></video>
      </CardMedia>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          #Bulati_hai_Magar_Jane_Ka_nahi #Savage_guy #Meme #Funny
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
      <a href={v10} target="_blank" download>
        <IconButton aria-label="download">
          <GetAppIcon />
        </IconButton>
        </a>
      </CardActions>
    </Card>
 </>
  );
}